<template>
    <div class="text-component-viewer" :style="computedStyle">
        {{ item.text || 'Testo' }}
    </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import * as OM from '@/model';

@Options({})
export default class TextComponentViewer extends Vue {
    @Prop() item: OM.TextComponent;

    get computedStyle() {
        const style: any = {};

        if (this.item.fontSize)   style.fontSize   = this.item.fontSize + 'px';
        if (this.item.fontFamily) style.fontFamily  = this.item.fontFamily;
        if (this.item.color)      style.color       = this.item.color;
        if (this.item.fontWeight) style.fontWeight  = this.item.fontWeight;
        if (this.item.textAlign)  style.textAlign   = this.item.textAlign;

        if (this.item.width)  style.width  = this.item.width  + 'px';
        if (this.item.height) style.height = this.item.height + 'px';

        return style;
    }
}
</script>

<style scoped>
.text-component-viewer {
    white-space: pre-wrap;
    word-wrap: break-word;
    display: inline-block;
    min-width: 20px;
    min-height: 20px;
    overflow: hidden;
}
</style>
